import { Flex } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';
import {
  FormFieldFileUploadArray,
  FormFieldRadio,
  FormFieldTextInput
} from '@publishing-engine/domain/types/article';
import { CustomFormFieldComponent } from 'src/components/FormField';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import ConditionalWrapper from '../../../../../../components/ConditionalWrapper';

interface IProps {
  draftSubmissionId: string;
  LicensesAndPermissionsConfig: FormFieldRadio<'metadata.LicensesAndPermissions'>;
  LicensesAndPermissionsReproducedContentConfig?: FormFieldTextInput<'metadata.LicensesAndPermissionsReproducedContent'>;
  LicensesAndPermissionsFilesConfig?: FormFieldFileUploadArray<'fileSet.LicensesAndPermissionsFiles'>;
}

const LicensesAndPermissionForm = ({
  draftSubmissionId,
  LicensesAndPermissionsConfig,
  LicensesAndPermissionsFilesConfig,
  LicensesAndPermissionsReproducedContentConfig
}: IProps) => {
  const { watch } = useFormContext<ISubmissionFormData>();
  const {
    caseDataFields: { main: licensesAndPermissionsFieldName }
  } = LicensesAndPermissionsConfig || { caseDataFields: { main: 'unknown' } };

  const licensesAndPermissionValue = watch(licensesAndPermissionsFieldName);

  const isValueSelected =
    licensesAndPermissionValue ===
    LicensesAndPermissionsReproducedContentConfig?.params
      ?.externalFieldDependency?.value;

  return (
    <Flex flexDirection="column" background="surfacePrimaryFill" width="100%">
      {LicensesAndPermissionsConfig && (
        <Flex padding={8}>
          <CustomFormFieldComponent
            config={LicensesAndPermissionsConfig}
            roleType="author"
          />
        </Flex>
      )}

      <ConditionalWrapper
        condition={isValueSelected}
        wrapper={children => (
          <Flex background="surfacePrimaryFill" padding={8} paddingTop={0}>
            <Flex
              flexDirection="column"
              background="surfaceSecondaryFill"
              padding={8}
              paddingTop={5}
              gap={3}
            >
              {children}
            </Flex>
          </Flex>
        )}
      >
        {LicensesAndPermissionsReproducedContentConfig && (
          <CustomFormFieldComponent
            config={LicensesAndPermissionsReproducedContentConfig}
            placeholder="List any reused content such as text excerpts, figures, datasets, etc., including where it was originally published."
          />
        )}

        {LicensesAndPermissionsFilesConfig && (
          <CustomFormFieldComponent
            config={LicensesAndPermissionsFilesConfig}
            submissionId={draftSubmissionId}
          />
        )}
      </ConditionalWrapper>
    </Flex>
  );
};

export default LicensesAndPermissionForm;
